import { render, staticRenderFns } from "./MissionsHandler.vue?vue&type=template&id=1062709e&scoped=true"
import script from "./MissionsHandler.vue?vue&type=script&lang=js"
export * from "./MissionsHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1062709e",
  null
  
)

export default component.exports